import React from "react";
import { getServerUri } from "../modules/uriUtility";
import _ from "lodash";
import DialogDeleteShell from "./DialogDeleteShell";

export default function dialogImageDelete(props) {
  const file = _.get(props, "imageToDelete.file", "");
  const ext = file.includes(".") ? file.substring(file.lastIndexOf(".")) : "";
  const baseName = _.get(props, "imageToDelete.uploadedFileName") || _.get(props, "imageToDelete.name") || file;
  const assetName = baseName && !baseName.includes(".") ? baseName + ext : baseName;

  const handleDelete = (progressID) => {
    return fetch(getServerUri("media/deleteOne"), {
      method: "DELETE",
      headers: { "content-type": "application/x-www-form-urlencoded" },
      body: new URLSearchParams({
        accessToken: localStorage.getItem("session.accessToken"),
        imageID: props.imageToDelete._id,
        progressID: progressID || "",
      }),
    }).then((response) => {
      if (response.status === 200) {
        let newImages = _.cloneDeep(props.images);
        newImages.splice(
          newImages.indexOf(newImages.filter((img) => img._id === props.imageToDelete._id)[0]),
          1
        );
        props.deleteImageFromMedia(props.imageToDelete._id);
        props.setImages(newImages);
        if (newImages.length > 0) {
          if (props.imageToDelete._id === props.selectedImageID) props.selectImage(newImages[0]._id);
        } else props.selectImage("");
        props.createSnackbar("Image deleted", "success");
        props.onAfterDelete?.();
        return true;
      } else {
        response.text().then(console.log).catch(console.error);
        return false;
      }
    });
  };

  return (
    <DialogDeleteShell
      isOpen={props.isOpen}
      setIsOpen={props.setIsOpen}
      assetName={assetName}
      assetID={_.get(props, "imageToDelete._id")}
      assetFile={_.get(props, "imageToDelete.file")}
      assetType="image"
      onConfirmDelete={handleDelete}
      createSnackbar={props.createSnackbar}
      errorMessage="An error occurred deleting the image."
    />
  );
}
